import { render, staticRenderFns } from "./Green.vue?vue&type=template&id=2149fda6&"
import script from "./Green.vue?vue&type=script&lang=js&"
export * from "./Green.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2149fda6')) {
      api.createRecord('2149fda6', component.options)
    } else {
      api.reload('2149fda6', component.options)
    }
    module.hot.accept("./Green.vue?vue&type=template&id=2149fda6&", function () {
      api.rerender('2149fda6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/green/Green.vue"
export default component.exports